import React, { useEffect, useState } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useAppContext } from "store/context";
import Notifications from "./components/Notifications";
import SkeletonContent from "./components/SkeletonContent";
import Header from "../Header";
import useStyles from "./components/styles";

const NotificationsContainer = ({ merchant_id }) => {
  const classes = useStyles();
  const { firebase } = useAppContext();
  const [data, loading] = useDocumentData(firebase.firestore().collection("notifications").doc(merchant_id));
  const reconcileEmployees = firebase.functions().httpsCallable("reconcileEmployees");
  const [reconciled, setReconciled] = useState(false);

  useEffect(() => {
    const reconcile = async () => {
      const { data: success } = await reconcileEmployees();
      setReconciled(success);
    };
    reconcile();
    // eslint-disable-next-line
  }, []);

  const updateTwilio = async (twilio_settings) => {
    await firebase.firestore().collection("notifications").doc(merchant_id).set({ twilio_settings }, { merge: true });
  };

  const updateTeam = async (team_members) => {
    await firebase.firestore().collection("notifications").doc(merchant_id).set({ team_members }, { merge: true });
  };

  return (
    <div className={classes.root}>
      <Header title="SMS Team Member(s) on new online order..." />
      {loading || !data || !reconciled ? (
        <SkeletonContent />
      ) : (
        <Notifications notifications={data} handleTeamUpdate={updateTeam} handleTwilioUpdate={updateTwilio} />
      )}
    </div>
  );
};

export default NotificationsContainer;
